import React, { useEffect, useState } from 'react';
import { Table, Button, Tag, Space, Popconfirm, message, Select } from 'antd';
import { PlusOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/api';

const typeMap = { family: '亲子家庭', social: '白领社交', corp: '企业团建' };
const typeColors = { family: 'green', social: 'orange', corp: 'blue' };
const statusMap = { draft: '草稿', published: '已发布', full: '已满员', ended: '已结束', offline: '已下架' };
const statusColors = { draft: 'default', published: 'green', full: 'orange', ended: 'blue', offline: 'red' };

export default function Activities() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [filters, setFilters] = useState({ status: '', type: '' });
  const navigate = useNavigate();

  useEffect(() => { loadData(); }, [pagination.current, filters]);

  async function loadData() {
    setLoading(true);
    try {
      const res = await request.get('/activities/admin/list', {
        params: { page: pagination.current, pageSize: pagination.pageSize, ...filters }
      });
      setData(res.data.list);
      setPagination(prev => ({ ...prev, total: res.data.total }));
    } catch (e) {} finally { setLoading(false); }
  }

  async function handleOffline(id) {
    try {
      await request.post(`/activities/${id}/offline`);
      message.success('已下架');
      loadData();
    } catch (e) { message.error(e.message || '操作失败'); }
  }

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '活动名称', dataIndex: 'title', ellipsis: true },
    { title: '类型', dataIndex: 'type', render: t => <Tag color={typeColors[t]}>{typeMap[t]}</Tag>, width: 100 },
    { title: '日期', dataIndex: 'activityDate', render: d => new Date(d).toLocaleDateString('zh-CN'), width: 120 },
    { title: '报名', key: 'count', width: 100,
      render: (_, r) => `${r.regCount || 0}/${r.maxParticipants}` },
    { title: '状态', dataIndex: 'status', width: 100,
      render: s => <Tag color={statusColors[s]}>{statusMap[s]}</Tag> },
    { title: '操作', key: 'action', width: 220,
      render: (_, r) => (
        <Space>
          <Button size="small" icon={<EyeOutlined />}
            onClick={() => navigate(`/registrations/${r.id}`)}>报名</Button>
          <Button size="small" icon={<EditOutlined />}
            onClick={() => navigate(`/activities/${r.id}/edit`)}>编辑</Button>
          {r.status === 'published' && (
            <Popconfirm title="确定下架该活动？" onConfirm={() => handleOffline(r.id)}>
              <Button size="small" danger>下架</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>活动管理</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/activities/create')}>
          创建活动
        </Button>
      </div>
      <div style={{ marginBottom: 16, display: 'flex', gap: 12 }}>
        <Select placeholder="活动状态" allowClear style={{ width: 140 }}
          value={filters.status || undefined}
          onChange={v => { setFilters({ ...filters, status: v || '' }); setPagination(prev => ({ ...prev, current: 1 })); }}
          options={Object.entries(statusMap).map(([k, v]) => ({ value: k, label: v }))}
        />
        <Select placeholder="活动类型" allowClear style={{ width: 140 }}
          value={filters.type || undefined}
          onChange={v => { setFilters({ ...filters, type: v || '' }); setPagination(prev => ({ ...prev, current: 1 })); }}
          options={Object.entries(typeMap).map(([k, v]) => ({ value: k, label: v }))}
        />
      </div>
      <Table columns={columns} dataSource={data} rowKey="id" loading={loading}
        pagination={{
          ...pagination,
          showTotal: total => `共 ${total} 条`,
          onChange: (page, pageSize) => setPagination({ ...pagination, current: page, pageSize }),
        }}
      />
    </div>
  );
}
